import { LoadState } from "../../constants/enums";

export interface IUserMappingState {
  userMapList: IUserMapRecord[];
  userMapListLoading: LoadState;
  userMapListTotalRecords: number;
  userMapDetailsList: IUserMapRecord[];
  userMapDetailsLoading: LoadState;
  userMapDetailsTotalRecords: number;
}

/** Individual record returned by GET /import-utility/get-user-map and get-user-map-details */
export interface IUserMapRecord {
  user_map_code: string;
  full_name: string;
  user_code: string;
  status: string;
  user_fact_id: number;
  email: string;
  role_name: string;
  create_ts: string | null;
  [key: string]: any;
}

/** Payload sent to POST /import-utility/set-use-map */
export interface ISetUserMapPayload {
  user_map_code: string | null;
  file_path: string | null;
  file_type: string | null;
  start_row: number | null;
  end_row: number | null;
  status: string;
  mapping_data: { [key: string]: string } | null;
}

/** Response from POST /import-utility/set-use-map */
export interface ISetUserMapResponse {
  user_map_code: number;
  status: string;
}

export const initialUserMappingState: IUserMappingState = {
  userMapList: [],
  userMapListLoading: LoadState.NotLoaded,
  userMapListTotalRecords: 0,
  userMapDetailsList: [],
  userMapDetailsLoading: LoadState.NotLoaded,
  userMapDetailsTotalRecords: 0,
};
